export default __webpack_public_path__ + "static/featured-properties-img4-707206a6a792ecd7e749cf66feed67fa.jpg";